<template>
  <div ref="modal" class="z-max fixed inset-0 items-center justify-center hidden">
    <div
      @click="hide(true)"
      class="absolute z-0 w-full h-full duration-200 opacity-0"
      :class="{'bg-black': theme === 'light', 'bg-concrete': theme === 'dark'}"
    ></div>
    <div
      class="z-1 absolute flex flex-col gap-4 p-4 duration-200 translate-y-2 opacity-0"
      :class="{'inset-0 w-full h-full rounded-none': fullscreen, 'w-[358px] rounded-lg': !fullscreen, [background]: true}"
    >
      <slot></slot>
      <div class="flex gap-4" v-if="actionBtns">
        <t-button
          @click.native="
            $emit('cancelBtn')
            hide()
          "
        >
          <t-text>Cancel</t-text>
        </t-button>
        <t-button
          ref="btn"
          @click.native="
            $emit('confirmBtn')
            hide()
          "
          color="branded"
        >
          <t-text>Confirm</t-text>
        </t-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-modal',
    props: {
      actionBtns: {
        type: Boolean,
        default: true
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      background: {
        type: String,
        default: 'bg-white'
      }
    },
    computed: {
      ...mapGetters(['theme'])
    },
    methods: {
      show() {
        this.$emit('beforeShow')
        if (!this.$refs.modal) return
        this.$refs.modal.classList.replace('hidden', 'flex')
        setTimeout(() => {
          if (!this.$refs.modal) return
          this.$refs.modal.firstChild.classList.replace('opacity-0', 'opacity-50')
          setTimeout(() => {
            if (!this.$refs.modal) return
            this.$refs.modal.lastChild.classList.replace('opacity-0', 'opacity-100')
            this.$refs.modal.lastChild.classList.replace('translate-y-2', 'translate-y-0')
            this.$emit('show')
          }, 50)
        }, 0)
      },
      hide(internal = false) {
        if (internal) this.$emit('beforeHide')
        if (!this.$refs.modal) return
        this.$refs.modal.lastChild.classList.replace('opacity-100', 'opacity-0')
        this.$refs.modal.lastChild.classList.replace('translate-y-0', 'translate-y-2')
        setTimeout(() => {
          if (!this.$refs.modal) return
          this.$refs.modal.firstChild.classList.replace('opacity-50', 'opacity-0')
        }, 50)
        setTimeout(() => {
          if (!this.$refs.modal) return
          this.$refs.modal.classList.replace('flex', 'hidden')
          if (internal) this.$emit('hide')
          this.$forceUpdate()
        }, 250)
      }
    }
  }
</script>
